// sd-variant-fix.js — carrega variantes reais via /products/handle.js
(function(){
  function lpLoadVariants(callback) {
    // Pega o handle do produto pelo canonical link ou URL
    var canonical = document.querySelector('link[rel="canonical"]');
    var handle = '';
    if (canonical) {
      var parts = canonical.href.replace(/\/$/, '').split('/');
      handle = parts[parts.length - 1].split('?')[0];
    } else {
      var urlParts = window.location.pathname.replace(/\/$/, '').split('/');
      handle = urlParts[urlParts.length - 1].split('?')[0];
    }
    if (!handle) { callback(null); return; }

    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var variants = data.variants || [];
        var ids = { 'sem-nome': null, 'com-nome': null };
        variants.forEach(function(v) {
          var title = (v.title || '').toLowerCase();
          if (title.indexOf('nome') > -1 || title.indexOf('frase') > -1) {
            ids['com-nome'] = v.id;
          } else {
            if (!ids['sem-nome']) ids['sem-nome'] = v.id;
          }
        });
        // Fallback: se só tem 2 variantes e não identificou com-nome pelo título
        if (!ids['com-nome'] && variants.length === 2) {
          ids['com-nome'] = variants[1].id;
        }
        callback(ids);
      })
      .catch(function(){ callback(null); });
  }

  function applyIds(ids) {
    if (!ids || (!ids['sem-nome'] && !ids['com-nome'])) return;
    window.LP_VARIANT_IDS = ids;
    console.log('[SD Fix] LP_VARIANT_IDS carregados da API:', ids);
  }

  function patchFunctions(ids) {
    if (window._sdPatched) return;
    if (typeof window.lpAddToCart !== 'function') return;
    window._sdPatched = true;

    var origATC = window.lpAddToCart;
    window.lpAddToCart = function() {
      window.LP_VARIANT_IDS = ids;
      origATC();
    };

    if (typeof window.lpVariantChange === 'function') {
      var origVC = window.lpVariantChange;
      window.lpVariantChange = function(input) {
        window.LP_VARIANT_IDS = ids;
        origVC(input);
      };
    }
    console.log('[SD Fix] Patch aplicado com IDs reais:', ids);
  }

  // Carrega os IDs reais assim que possível
  lpLoadVariants(function(ids) {
    if (!ids) return;
    applyIds(ids);

    // Patch imediato se funções já existem
    patchFunctions(ids);

    // Continua tentando patchear caso as funções ainda não existam
    var attempts = 0;
    var timer = setInterval(function() {
      attempts++;
      patchFunctions(ids);
      if (window._sdPatched || attempts > 30) clearInterval(timer);
    }, 200);
  });
})();